import script from "./Location.vue?vue&type=script&setup=true&lang=ts"
export * from "./Location.vue?vue&type=script&setup=true&lang=ts"

import "./Location.vue?vue&type=style&index=0&id=7c7c9b34&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7c9b34"]])

export default __exports__